import { memo } from 'react';

import ChatGPTIconSVG from '@/assets/chatgpt-filled-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IChatGPTIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={ChatGPTIconSVG} {...props} />;

export const ChatGPTIcon = memo(IChatGPTIcon) as typeof IChatGPTIcon;
